// Коди помилок сервера → зрозумілі повідомлення українською.
const MESSAGES: Record<string, string> = {
  forbidden: 'Немає доступу до цієї сторінки.',
  unauthorized: 'Увійдіть, щоб продовжити.',
  lesson_locked: 'Цей урок ще закритий. Спершу пройди попередній.',
  no_attempts_left: 'Спроби перевірки вичерпано.',
  steps_incomplete: 'Спершу розв’яжи всі завдання уроку.',
  session_closed: 'Ця спроба вже завершена.',
  session_not_found: 'Сесію не знайдено. Відкрий урок ще раз.',
  already_answered: 'На це завдання вже є відповідь.',
  invalid_credentials: 'Неправильний логін або пароль.',
  account_suspended: 'Доступ призупинено. Зверніться до батьків.',
  rate_limited: 'Забагато спроб. Зачекайте кілька хвилин і спробуйте знову.',
  weak_password: 'Пароль має містити щонайменше 8 символів.',
  display_name_invalid: 'Вкажіть ім’я (до 40 символів).',
  grade_invalid: 'Клас — число від 1 до 11.',
  email_not_confirmed: 'Спершу підтвердіть email.',
  email_invalid: 'Перевірте email.',
  consent_required: 'Потрібна згода з умовами та обробкою даних.',
  session_open: 'Перевірку ще не завершено.',
  session_revoked: 'Сесія завершилася. Увійди ще раз.',
  already_sent: 'Цю подію вже доставлено в CRM.',
  outbox_not_found: 'Подію не знайдено.',
  username_unavailable: 'Не вдалося створити логін. Спробуйте ще раз.',
  draft_has_errors: 'У чернетці є помилки — виправте їх перед надсиланням.',
  not_approved: 'Спершу методист має затвердити чернетку.',
  draft_not_found: 'Спершу збережіть чернетку.',
  title_invalid: 'Назва — від 1 до 80 символів.',
  teacher_not_found: 'Користувача з роллю викладача не знайдено.',
  child_not_found: 'Учня з таким логіном не знайдено.',
  user_not_found_or_unconfirmed: 'Користувача не знайдено або email не підтверджено.',
  cannot_revoke_self: 'Не можна зняти роль адміна із себе.',
  bad_path: 'Недопустима назва файлу.',
  file_required: 'Оберіть файл.',
  unsupported_media_type: 'Цей тип файлу не підтримується: PNG, JPEG, WebP, MP3, M4A, OGG, MP4, WebM або VTT.',
  file_too_large: 'Файл завеликий: зображення до 2 МБ, аудіо до 10 МБ, відео до 50 МБ, субтитри до 1 МБ.',
  media_in_use: 'Файл використовується в уроці — спершу приберіть його з уроку.',
  media_not_found: 'Файл уже видалено.',
  payment_required: 'Цей урок відкриється після оплати навчання.',
  too_many_attempts: 'Забагато невдалих спроб. Спробуйте ще раз через 15 хвилин.',
  code_invalid: 'Неправильний або прострочений код. Перевірте останній лист і спробуйте ще раз.',
  reason_required: 'Вкажіть причину (щонайменше 3 символи).',
  days_invalid: 'Строк — від 1 до 3650 днів або порожньо (без строку).',
  no_active_access: 'У дитини немає активного доступу.',
  phone_invalid: 'Перевірте номер телефону.',
  setting_invalid: 'Неприпустиме значення налаштування.',
  setting_not_editable: 'Це налаштування не змінюється з адмінки.',
  trial_not_completed: 'Спершу заверши пробний урок.',
  already_paid: 'Навчання вже оплачено.',
  no_parent_email: 'Не знайдено підтвердженого email батьків.',
  network: 'Немає з’єднання з сервером. Перевірте інтернет і спробуйте ще раз.',
  'Email not confirmed': 'Email ще не підтверджено. Перевірте пошту або надішліть лист повторно.',
  'Invalid login credentials': 'Неправильний email або пароль.',
  over_email_send_rate_limit: 'Лист уже надіслано. Повторити можна за хвилину.',
};
export class ApiError extends Error {
  constructor(public code: string, message?: string) { super(message ?? code); }
}
export function messageFor(e: unknown): string {
  const code = e instanceof ApiError ? e.code : e instanceof Error ? e.message : String(e);
  for (const [k, v] of Object.entries(MESSAGES)) if (code.includes(k)) return v;
  if (/fetch|network/i.test(code)) return MESSAGES.network;
  return 'Щось пішло не так. Спробуйте ще раз.';
}
